import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLayersCount = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2938_31121",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 100,
		height: 100,
		children: /* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 99,
			height: 99,
			fill: "#C4C4C4",
			stroke: "#9EA9B9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_2938_31121)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M77.4052 48.6016C77.4052 44.0346 79.1726 40.3082 81.4219 40.028L81.4219 40L34.2985 40C31.9287 40 30.0007 43.8386 30.0007 48.6017C30.0007 53.3648 31.9287 57.2034 34.2985 57.2034L81.4219 57.2034L81.4219 57.1754C79.1726 56.8951 77.4052 53.1687 77.4052 48.6016Z",
				fill: "#FDF1E6",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M77.4044 48.6017C77.4044 53.1687 79.1718 56.8952 81.4211 57.1753C81.5014 57.2033 81.6219 57.2033 81.7022 57.2033C84.072 57.2034 86 53.3648 86 48.6017C86 43.8386 84.072 40 81.7022 40C81.6219 40 81.5014 40 81.4211 40.028C79.1718 40.3082 77.4044 44.0347 77.4044 48.6017Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M76.4052 31.6016C76.4052 27.0346 78.1726 23.3082 80.4219 23.028L80.4219 23L33.2985 23C30.9287 23 29.0007 26.8386 29.0007 31.6017C29.0007 36.3648 30.9287 40.2034 33.2985 40.2034L80.4219 40.2034L80.4219 40.1754C78.1726 39.8951 76.4052 36.1687 76.4052 31.6016Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M76.4044 31.6017C76.4044 36.1687 78.1718 39.8952 80.4211 40.1753C80.5014 40.2033 80.6219 40.2033 80.7022 40.2033C83.072 40.2034 85 36.3648 85 31.6017C85 26.8386 83.072 23 80.7022 23C80.6219 23 80.5014 23 80.4211 23.028C78.1718 23.3082 76.4044 27.0347 76.4044 31.6017Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M69.4052 57.6016C69.4052 53.0346 71.1726 49.3082 73.4219 49.028L73.4219 49L26.2985 49C23.9287 49 22.0007 52.8386 22.0007 57.6017C22.0007 62.3648 23.9287 66.2034 26.2985 66.2034L73.4219 66.2034L73.4219 66.1754C71.1726 65.8951 69.4052 62.1687 69.4052 57.6016Z",
				fill: "#FDF1E6",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M69.4044 57.6017C69.4044 62.1687 71.1718 65.8952 73.4211 66.1753C73.5014 66.2033 73.6219 66.2033 73.7022 66.2033C76.072 66.2034 78 62.3648 78 57.6017C78 52.8386 76.072 49 73.7022 49C73.6219 49 73.5014 49 73.4211 49.028C71.1718 49.3082 69.4044 53.0347 69.4044 57.6017Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M68.4052 40.6016C68.4052 36.0346 70.1726 32.3082 72.4219 32.028L72.4219 32L25.2985 32C22.9287 32 21.0007 35.8386 21.0007 40.6017C21.0007 45.3648 22.9287 49.2034 25.2985 49.2034L72.4219 49.2034L72.4219 49.1754C70.1726 48.8951 68.4052 45.1687 68.4052 40.6016Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M68.4044 40.6017C68.4044 45.1687 70.1718 48.8952 72.4211 49.1753C72.5014 49.2033 72.6219 49.2033 72.7022 49.2033C75.072 49.2034 77 45.3648 77 40.6017C77 35.8386 75.072 32 72.7022 32C72.6219 32 72.5014 32 72.4211 32.028C70.1718 32.3082 68.4044 36.0347 68.4044 40.6017Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M61.4052 66.6016C61.4052 62.0346 63.1726 58.3082 65.4219 58.028L65.4219 58L18.2985 58C15.9287 58 14.0007 61.8386 14.0007 66.6017C14.0007 71.3648 15.9287 75.2034 18.2985 75.2034L65.4219 75.2034L65.4219 75.1754C63.1726 74.8951 61.4052 71.1687 61.4052 66.6016Z",
				fill: "#FDF1E6",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M61.4044 66.6017C61.4044 71.1687 63.1718 74.8952 65.4211 75.1753C65.5014 75.2033 65.6219 75.2033 65.7022 75.2033C68.072 75.2034 70 71.3648 70 66.6017C70 61.8386 68.072 58 65.7022 58C65.6219 58 65.5014 58 65.4211 58.028C63.1718 58.3082 61.4044 62.0347 61.4044 66.6017Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M60.4052 49.6016C60.4052 45.0346 62.1726 41.3082 64.4219 41.028L64.4219 41L17.2985 41C14.9287 41 13.0007 44.8386 13.0007 49.6017C13.0007 54.3648 14.9287 58.2034 17.2985 58.2034L64.4219 58.2034L64.4219 58.1754C62.1726 57.8951 60.4052 54.1687 60.4052 49.6016Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M60.4044 49.6017C60.4044 54.1687 62.1718 57.8952 64.4211 58.1753C64.5014 58.2033 64.6219 58.2033 64.7022 58.2033C67.072 58.2034 69 54.3648 69 49.6017C69 44.8386 67.072 41 64.7022 41C64.6219 41 64.5014 41 64.4211 41.028C62.1718 41.3082 60.4044 45.0347 60.4044 49.6017Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			})
		]
	})]
});
export default SvgLayersCount;
